import { styled } from "@pigment-css/react";
import { RowItem, RowList } from "@acto/taskpane/field-sales-2/components/primitives/Card";

export const LineItemList = styled(RowList)(({ theme }) => ({
  gap: theme.fieldSalesTwo.spacing[24],
  "& > li:not(:first-of-type)": {
    paddingTop: theme.fieldSalesTwo.spacing[24],
  },
}));

const TopRow = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
});

const Name = styled("span")(({ theme }) => ({
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[15],
  fontWeight: theme.fieldSalesTwo.font.weight[520],
  lineHeight: theme.fieldSalesTwo.font.lineHeight[148],
  color: theme.fieldSalesTwo.colors.neutral[900],
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  minWidth: 0,
  flex: 1,
}));

const Price = styled("span")(({ theme }) => ({
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[15],
  fontWeight: theme.fieldSalesTwo.font.weight[520],
  lineHeight: theme.fieldSalesTwo.font.lineHeight[148],
  color: theme.fieldSalesTwo.colors.neutral[900],
  whiteSpace: "nowrap",
  flexShrink: 0,
  marginLeft: 12,
}));

const Meta = styled("span")(({ theme }) => ({
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[14],
  fontWeight: theme.fieldSalesTwo.font.weight[500],
  lineHeight: theme.fieldSalesTwo.font.lineHeight[168],
  color: theme.fieldSalesTwo.colors.neutral[800],
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
}));

interface LineItemRowProps {
  name: string;
  price: string;
  meta: string;
}

export function LineItemRow({ name, price, meta }: LineItemRowProps) {
  return (
    <RowItem>
      <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column" }}>
        <TopRow>
          <Name>{name}</Name>
          <Price>{price}</Price>
        </TopRow>
        <Meta>{meta}</Meta>
      </div>
    </RowItem>
  );
}
